import React from "react";
const HelperLabel = ({ label, forId }) => {
    return (React.createElement("div", { "data-ecom-helper-box": "", className: "m-t-half m-b-half" },
        React.createElement("label", { "data-ecom-inputlabel": "no-margin", htmlFor: forId }, label)));
};
export default HelperLabel;
